import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData, getcountries } from '../../../services/admin/refundStatus/refundServices';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';


const RefundPending = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '',
    pr_id : '',
    series : '',
    sub_domain : '',
    name : '',
    email : '',
    countries : '',
    phone_no : '',
    currency : '',
    actual_amount : '',
    refund_amount : '',
    remaining_amount : '',
    paypal_email : '',
    refund_through : '',
    bank_name : '',
    bank_address : '',
    bank_country : '',
    postal_code : '',
    account_number : '',
    swift_code_ifsc_code : '',
    iban_code : '',
    refund_date : '',
    transaction_id : '',
    status:0,
    updatedAt : '' });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [dropdownData, setDropdownData] = useState({
      countries: []
  });
  
  // Fetch data
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ status: 0 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries()
      ]);
  
      setDropdownData({
        countries: country
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.refund_date || !form.transaction_id) {
      alert("Refund Date and Transaction ID are required!");
      return;
    }

    try {
      if (modalType === 'edit') {
        const updatedForm = { ...form, status: 1 }; // Set status to 1
        await updateData(updatedForm);
      }
      fetchData();
      setShowModal(false);
    } catch (error) {
      console.error('Error during form submission:', error);
    }
  };

  const openModal = (type, data = { id: '', refund_date: '', transaction_id: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode?.toUpperCase()) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'INR': return '₹';
      case 'GBP': return '£';
      case 'RUB': return '₽';
      case 'THB': return '฿';
      default: return currencyCode || '';
    }
  };

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };
  

  // Memoized filtered data based on search query
 const filteredData = useMemo(() => {
     return dataList.filter((data) => data.name.toLowerCase().includes(searchText.toLowerCase()) ||
     data.sub_domain.toLowerCase().includes(searchText.toLowerCase())  ||
     data.actual_amount.toString().includes(searchText.toLowerCase()) ||
     data.refund_amount.toString().includes(searchText.toLowerCase()) ||
     data.countries.toLowerCase().includes(searchText.toLowerCase()) 
   ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
      name: 'Series',
      selector: (row) => row.series,
      sortable: true,
      width: '10%',
    },
    {
      name: 'Sub Domain',
      selector: (row) => row.sub_domain || 'N/A',
      sortable: true,
      width: '15%',
    },
    {
      name: 'Name',
      // selector: (row) => row.name || 'N/A',
      cell: (row) => <span title={row.name}>{row.name ||'N/A' }</span>,
      sortable: true,
      width: '15%',
    },
    {
      name: 'Country',
      // selector: (row) =>getCountryName(row.countries || 'N/A'),
      cell: (row) => <span title={getCountryName(row.countries)}>{getCountryName(row.countries)}</span>,
      sortable: true,
    },
    { name: 'Actual Amount', selector: (row) => { const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.actual_amount || 'N/A'}</b>;
    },sortable: true,
    width: '15%'
    },
    { name: 'Refund Amount', selector: (row) => { const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.refund_amount || 'N/A'}</b>;
    },sortable: true,
    width: '15%',
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>Edit</Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 text-dark">Revenue Management / Refund status / Pending Refund Details</p>
            </div>

          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add Refund' : 'Edit Refund'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Pending Refund Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>User Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>{form.name}</td>
                      </tr>
                      <tr>
                        <td>Payment ID</td>
                        <td>{form.pr_id}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{form.email}</td>
                      </tr>
                      <tr>
                        <td>Phone No</td>
                        <td>{form.phone_no}</td>
                      </tr>
                      <tr>
                        <td>Countries</td>
                        <td>{getCountryName(form.countries)}</td>
                      </tr>
                      <tr>
                        <td>Currency</td>
                        <td>{form.currency}</td>
                      </tr>
                      <tr>
                        <td>Actual Amount</td>
                        <td>{form.actual_amount}</td>
                      </tr>
                      <tr>
                        <td>Refund Amount</td>
                        <td>{form.refund_amount}</td>
                      </tr>
                      <tr>
                        <td>Remaining Amount</td>
                        <td>{form.remaining_amount}</td>
                      </tr>
                      <tr>
                        <td>Series</td>
                        <td>{form.series}</td>
                      </tr>
                      <tr>
                        <td>Subdomain</td>
                        <td>{form.sub_domain}</td>
                      </tr>
                      <tr><td>Refund Through</td><td>{form.refund_through}</td></tr>
                    </tbody>
                    <br></br>
                    {/* Paypal Details (Only If Data Exists) */}
                {form.paypal_email && (
                  <>
                    <thead>
                      <tr><th className="bg-secondary text-white" colSpan={2}>PayPal Details</th></tr>
                    </thead>
                    <tbody>
                      <tr><td>PayPal Email/ID</td><td>{form.paypal_email}</td></tr>
                    </tbody>
                  </>
                )}

                {/* Bank Details (Only If Data Exists) */}
                {(form.bank_name || form.bank_address || form.bank_country || form.postal_code || form.account_number || form.swift_code_ifsc_code || form.iban_code) && (
                  <>
                    <thead>
                      <tr><th className="bg-secondary text-white" colSpan={2}>Bank Details</th></tr>
                    </thead>
                    <tbody>
                      {form.bank_name && <tr><td>Bank Name</td><td>{form.bank_name}</td></tr>}
                      {form.bank_address && <tr><td>Bank Address</td><td>{form.bank_address}</td></tr>}
                      {form.bank_country && <tr><td>Bank Country</td><td>{getCountryName(form.bank_country)}</td></tr>}
                      {form.postal_code && <tr><td>Postal Code</td><td>{form.postal_code}</td></tr>}
                      {form.account_number && <tr><td>Account Number</td><td>{form.account_number}</td></tr>}
                      {form.swift_code_ifsc_code && <tr><td>Swift/IFSC Code</td><td>{form.swift_code_ifsc_code}</td></tr>}
                      {form.iban_code && <tr><td>IBAN Code</td><td>{form.iban_code}</td></tr>}
                    </tbody>
                    </>
                )}
            
                  </Table>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Refund Date <small className="text-danger">*</small></Form.Label>
                  <Form.Control type="date" name="refund_date" value={form.refund_date} onChange={handleChange} required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Transaction ID <small className="text-danger">*</small></Form.Label>
                  <Form.Control type="text" name="transaction_id" value={form.transaction_id} onChange={handleChange} required />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleSubmit}>{modalType === 'add' ? 'Add' : 'Save'}</Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default RefundPending;
